import MsgInfo from "componentsv2/step/MsgInfo";

function StepForm({ name, nextWidget, nextMsg }) {
  return (
    <div id="step-form" key={name} className="mt-4">
      <MsgInfo msg={nextMsg.value} />
      {nextWidget.value}
    </div>
  );
}

export default StepForm;
